<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { CONVERSATION_STATUS } from 'shared/constants/messages';

const props = defineProps({
  status: {
    type: String,
    default: '',
  },
  showEmpty: {
    type: Boolean,
    default: false,
  },
});

const icons = {
  [CONVERSATION_STATUS.OPEN]: 'i-woot-status-open',
  [CONVERSATION_STATUS.RESOLVED]: 'i-woot-status-resolved',
  [CONVERSATION_STATUS.PENDING]: 'i-woot-status-pending',
  [CONVERSATION_STATUS.SNOOZED]: 'i-woot-status-snoozed',
};

const { t } = useI18n();
const statusLabel = computed(() =>
  icons[props.status]
    ? t(`CHAT_LIST.CHAT_STATUS_FILTER_ITEMS.${props.status}.TEXT`)
    : ''
);

const iconName = computed(() => {
  if (props.status && icons[props.status]) {
    return icons[props.status];
  }
  return props.showEmpty ? 'i-woot-status-empty' : '';
});
</script>

<template>
  <span
    v-tooltip.top="{
      content: statusLabel,
      delay: { show: 500, hide: 0 },
    }"
    :class="iconName"
    role="img"
    :aria-label="statusLabel"
    class="size-4 flex-shrink-0"
  />
</template>
